import React from 'react';

const ExperienceCard = ({ logo, name, job, duration, skills }) => {
  return (
    <div className="mc-panel flex w-full flex-col gap-6 p-6 md:p-8 md:flex-row md:gap-8 text-left transition-all duration-300 hover:-translate-y-1.5 hover:border-[#55ff55] hover:shadow-[0_0_20px_rgba(85,255,85,0.18)] group">
      
      {/* Logo container styled as a Minecraft slot */}
      <div className="mc-slot flex-shrink-0 w-16 h-16 md:w-20 md:h-20 flex items-center justify-center p-3 select-none transition-all duration-300 group-hover:bg-[#444] group-hover:scale-105 group-hover:border-[#55ff55] group-hover:shadow-[0_0_10px_rgba(85,255,85,0.3)]">
        <img className="w-full h-full object-contain transition-transform duration-300 group-hover:scale-110" src={logo} alt={name} />
      </div>

      {/* Text Content */}
      <div className="w-full text-[#e0e0e0]">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-[#ffff55] tracking-wide select-none transition-colors duration-300 group-hover:text-[#55ff55]">{name}</h2>
            <p className="text-md font-semibold text-[#55ff55] mt-0.5 transition-colors duration-300 group-hover:text-white">{job}</p>
          </div>
          <div className="inline-flex self-start md:self-center px-3 py-1 rounded-none text-md font-bold bg-[#1e1e1e] text-[#aaaaaa] border border-black shadow-[inset_-1px_-1px_0px_0px_#555,inset_1px_1px_0px_0px_#000] transition-all duration-300 group-hover:border-[#ffff55] group-hover:text-[#ffff55] group-hover:bg-[#2e2e2e]">
            {duration}
          </div>
        </div>
        
        <hr className="my-4 border-0 h-[2px] bg-black transition-colors duration-300 group-hover:bg-[#55ff55]" />
        
        <ul className="space-y-3 font-mono">
          {skills.map((skill, index) => (
            <li key={index} className="flex items-start gap-3 text-md text-[#aaaaaa] leading-relaxed transition-colors duration-200 hover:text-white">
              {/* Green block bullet */}
              <span className="inline-block w-3 h-3 bg-[#55ff55] border-2 border-black mt-1 flex-shrink-0 transition-transform duration-200 group-hover:scale-110" />
              <span>{skill}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default ExperienceCard;
